import { useQuery } from '@tanstack/react-query'
import { Constants } from 'constants/constants'
import { QueryKeys } from 'constants/query-keys'
import { IResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchMyTargetPerformanceGuestGoals } from 'queries/myTarget-performance/performance-metrics'
import { MPMEnvType } from 'utils/env'
import { getGreenfieldLocationFilter } from 'utils/greenfield'

interface MyTargetPerformanceGuestGoalsFetchProps {
    env: MPMEnvType
    accessToken: string
    location: string
    enabled?: boolean
}

export function useMyTargetPerformanceGuestGoals({
    env,
    accessToken,
    location,
    enabled = true,
}: MyTargetPerformanceGuestGoalsFetchProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const greenfieldCardNumber =
        Constants.GREENFIELD_CARDS.MY_TARGET_PERFORMANCE.GUEST_GOALS

    const filters = getGreenfieldLocationFilter(location)
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.MY_TARGET_PERFORMANCE_GUEST_GOALS, location],
        () =>
            fetchMyTargetPerformanceGuestGoals({
                env,
                accessToken,
                dynamicSubPath: greenfieldCardNumber,
                method: 'GET',
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
            enabled,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
